import * as mutations from '../../mutation-types'

export const processTableView = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_TABLE_VIEW, item)
}

export const createOrUpdateTableView = (store, item) => {
    return item.id ?
        updateTableView(store, item) :
        createTableView(store, item)
}

export const setTableViews = (store, items) => {
    _.each(items, item => processTableView(store, item))
}

export const fetchTableViewById = (store, id) => {
    return axios.get(`/api/table-views/${id}`)
        .then(res => {
            processTableView(store, res.data.data)
            return res
        })
}

export const createTableView = (store, item) => {
    item.created_by = item.created_by || store.getters.currentUserId

    return axios.post(`/api/table-views`, item)
        .then(res => {
            processTableView(store, res.data.data)

            return res
        })
}

export const updateTableView = (store, item) => {
    item.created_by = item.created_by || store.getters.currentUserId

    return axios.patch(`/api/table-views/${item.id}`, item)
        .then(res => {
            processTableView(store, res.data.data)

            return res
        })
}

export const toggleTableView = ({ commit }, tableViewId) => {
    commit(mutations.APPLY_TABLE_VIEW, tableViewId)
}

export const removeTableView = (store, item) => {
    return axios.delete(`/api/table-views/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_TABLE_VIEW, item)
            return res
        })
}

export const fetchTableColumnNames = (store, params) => {
    return axios.get(`/api/table-views/table-column-names`, { params })
        .then(res => {
            store.commit(mutations.SET_TABLE_COLUMN_NAMES, res.data.data)
            return res
        })
}
